
































import { Vue, Component, Prop } from 'vue-property-decorator';
import CountryFlag from '../CountryFlag.vue';

@Component({
  components: {
    'omegaup-countryflag': CountryFlag,
  },
})
export default class Username extends Vue {
  @Prop() username!: string;
  @Prop({ default: null }) name!: string;
  @Prop() classname!: string;
  @Prop() linkify!: boolean;
  @Prop({ default: '#' }) href!: string;
  @Prop() country!: string;
  @Prop({ default: false }) emitClickEvent!: boolean;

  get nameWithUsername(): string {
    if (this.name) {
      return `${this.name} (${this.username})`;
    }
    return this.username;
  }
}
